import { render, staticRenderFns } from "./SecondShow.vue?vue&type=template&id=1ad73482&scoped=true"
import script from "./SecondShow.vue?vue&type=script&lang=js"
export * from "./SecondShow.vue?vue&type=script&lang=js"
import style0 from "./SecondShow.vue?vue&type=style&index=0&id=1ad73482&prod&lang=less&scoped=true"
import style1 from "./SecondShow.vue?vue&type=style&index=1&id=1ad73482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad73482",
  null
  
)

export default component.exports